export const REDESIGN_CONTACT = {
    testName: 'redesing_page_service_contact',
    variants: {
        on: 'new_page_service_contact',
        off: 'old_page_service_contact',
    },
};
